import request from "@src/utils/request";
import { PaginatedResponse } from "@src/types/notification";
import { PaginationValues } from "@src/types/pagination";
import { SavedDistributorProduct } from "@src/types/savedDistributorProduct";
import type { Response } from "superagent";

export function createSavedDistributorProduct(distributorProductId: string) {
  return request()
    .post("/api/v1/saved-distributor-products/")
    .send({ distributor_product_id: distributorProductId });
}
type SavedForLaterPage = {
  totalCount?: number;
  totalPages?: number;
  page?: number;
  results: SavedDistributorProduct[];
};

export async function getSavedForLaterWithLivePricing(
  paginationFilters?: PaginationValues,
) {
  return request()
    .query({
      page: paginationFilters?.page,
      pageSize: paginationFilters?.pageSize,
    })
    .get("/api/v1/saved-distributor-products/")
    .send() as Promise<
    Response & {
      body: PaginatedResponse<SavedDistributorProduct> | SavedForLaterPage;
    }
  >;
}

export async function deleteSavedDistributorProduct(id: string) {
  return request().delete(`/api/v1/saved-distributor-products/${id}/`).send();
}
